<template>
    <v-data-table :headers="visibleHeaders" :items="items" :options.sync="options" :server-items-length="totalItems"
        :footer-props="{
            'items-per-page-options': [15, 50, 100],
            showFirstLastPage: true,
        }" :loading="loading" locale="nl-BE" item-key="id" :expanded.sync="expanded" dense>
        <template v-slot:header.column-sort>
            <v-menu :close-on-content-click="false" offset-y min-width="300">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn small icon v-bind="attrs" v-on="on"><v-icon small>mdi-drag-vertical</v-icon></v-btn>
                </template>
                <eod-card title="Kolommen">
                    <draggable class="d-flex flex-column h-full" v-model="headers" group="headers">
                        <div v-for="(element, index) in headers.map(item => ({...item, ...config.index.headers.find(h => h.value == item.value)})).filter(item => item)"
                            :key="index" :style="element.draggable == false ? 'display:none;' : ''">
                            <div class="d-flex align-center px-2">
                                <v-checkbox v-if="element.draggable !== false" class="mt-0 mr-0"
                                    :input-value="element.hidden || false"
                                    @change="val => setHeaderHidden(element, val)" :true-value="false" :false-value="true"
                                    hide-details></v-checkbox>
                                <div style="cursor: grab;">
                                    {{ element.text || element.value }}
                                </div>
                            </div>
                            <v-divider
                                v-if="index < headers.map(item => config.index.headers.find(h => h.value == item.value)).length - 1"
                                class="my-1"></v-divider>
                        </div>
                    </draggable>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <eod-btn @click="clearColumnConfig" color="error"><v-icon left>mdi-refresh</v-icon>Herstellen</eod-btn>
                    </v-card-actions>
                </eod-card> 
            </v-menu>
        </template>
        <template v-slot:header.selectable>
            <v-checkbox
                :input-value="allSelected"
                :indeterminate="someSelected"
                @change="toggleSelectAll"
                hide-details
                dense
                data-testid="select-all"
                class="mt-0 pt-0"
            ></v-checkbox>
        </template>
        <template v-slot:item="{ item, expand, isExpanded }">
            <tr :class="isExpanded ? 'grey lighten-3 elevation-3' : ''">
                <td v-if="selectable">
                    <v-checkbox :input-value="selection" :value="item" @change="item => $emit('selected', item)" v-if="!selectableRows || (selectableRows && selectableRows(item))" dense></v-checkbox>
                </td>
                <component v-for="(header, index) in visibleHeaders" ref="item" v-bind="componentProps" :key="index"
                    :is="header.component" :item="item" :fieldname="header.value" :config="config"
                    :readonly="item.isReadonly ? true : false"
                    :visible="(header.visible && header.visible(item)) || !header.visible" :extra="header.extra"
                    @update="getDataFromApi" :showDuplicate="showDuplicate" @duplicate="$emit('duplicate', item)"
                    :expand="expand" :isExpanded="isExpanded" @edit="editItemAction" @report="reportAction" @setFilter="(field, value, displayValue) => $emit('setFilter', field, value, displayValue)"
                    :colspan="index == visibleHeaders.length - 2 ? 2 : 1"></component>
            </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }" v-if="config.index.expanded">
            <component :is="config.index.expanded.component" :headers="headers" :item="item" :config="config"
                @updatedStatus="updatedStatus" @updateList="getDataFromApi"></component>
        </template>
    </v-data-table>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    props: {
        config: Object,
        filters: Array,
        timeFilters: Object,
        componentProps: Object,
        showDuplicate: Boolean,
        prepareItems: Function,
        alterVariables: Function,
        alterOptions: Function,
        editItemAction: {
            type: Function,
            default: () => { }
        },
        reportAction: {
            type: Function,
            default: () => { }
        },
        selectable: {
            type: Boolean,
            default: false
        },
        selection: {
            type: Array,
            default: () => []
        },
        selectableRows: Function
    },
    components: {
        draggable
    },
    data: () => ({
        totalItems: 0,
        items: [],
        loading: false,
        expanded: [],
        options: {},
        cancelRequest: null,
        childrenLoading: false,
        headers: [],
        visibleHeaders: [],
        updateDataTable: 1738,
    }),
    computed: {
        selectableItems() {
            return this.items.filter(item => !this.selectableRows || this.selectableRows(item));
        },
        allSelected() {
            return this.selectableItems.length > 0 && this.selectableItems.every(item => this.selection.find(s => s.id === item.id));
        },
        someSelected() {
            return this.selectableItems.some(item => this.selection.find(s => s.id === item.id)) && !this.allSelected;
        },
        visibleItems() {
            let items = [];
            for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                if (!item.hasOwnProperty('treeVisible') || item.treeVisible == true) {
                    items.push(item);
                }
            }
            return items;
        },
    },
    watch: {
        options: {
            handler() {
                localStorage.setItem(this.$eod.getUser().id + '-options-' + this.config.index.endpoint, JSON.stringify(this.options));
                this.getDataFromApi();
            },
            deep: true,
        },
        headers: {
            handler() {
                this.visibleHeaders = this.getVisibleHeaders();
                this.saveHeaders();
            },
            deep: true,
        },
        timeFilters: {
            // #1380: filter je op een datumveld via de tijds-widget, toon dan automatisch
            // de bijhorende kolom (indien die bestaat en verborgen is), zodat je ziet
            // waarop gefilterd wordt.
            handler(val) {
                if (val && val.field) {
                    const header = this.headers.find(h => h.value === val.field);
                    if (header && header.hidden) {
                        header.hidden = false;
                    }
                }
            },
            deep: true,
        },
    },
    created() {
        // Load header configuration
        //this.$eod.setUserConfiguration('headers', {});
        const headerConfig = this.$eod.getUser().configuration?.headers?.[this.config.index.route];
        if (headerConfig) {
            // Ensure all headers are present
            for (let i = 0; i < this.config.index.headers.length; i++) {
                const header = this.config.index.headers[i];
                if (!headerConfig.find(h => h.value == header.value)) {
                    headerConfig.push({ value: header.value, hidden: true});
                }
            }
            this.headers = headerConfig.map(config => ({...config, ...this.config.index.headers.find(item => (item.value == config.value))})).filter(item => item);
        } else {
            this.headers = this.config.index.headers.map(header => ({ value: header.value, hidden: header.defaultHidden || false, draggable: header.draggable || true }));
        }
    },
    mounted() {
        let options = localStorage.getItem(this.$eod.getUser().id + '-options-' + this.config.index.endpoint);
        if (options) {
            this.options = JSON.parse(options);
            if (this.options.itemsPerPage < 0) {
                this.options.itemsPerPage = 100;
            }
        }
    },
    methods: {
        toggleSelectAll(val) {
            let newSelection = [...this.selection];
            if (val) {
                // add all selectableItems that are not already in newSelection
                this.selectableItems.forEach(item => {
                    if (!newSelection.find(s => s.id === item.id)) {
                        newSelection.push(item);
                    }
                });
            } else {
                // remove all selectableItems from newSelection
                newSelection = newSelection.filter(s => !this.selectableItems.find(item => item.id === s.id));
            }
            this.$emit('selected', newSelection);
        },
        saveHeaders(){
            const currConfig = this.$eod.getUser().configuration?.headers || {};
            currConfig[this.config.index.route] = this.headers.map(item => ({
                value: item.value,
                hidden: item.hidden
            }));
            this.$eod.setUserConfiguration('headers', currConfig);
        },
        getVisibleHeaders(){
            const headers = [];

            if(this.selectable){
                headers.push({
                    value: 'selectable',
                    text:'',
                    width:50,
                    sortable:false
                });
            }

            for (let i = 0; i < this.headers.length; i++) {
                const header = this.headers[i];
                if (!header.hidden && header.value && header.draggable !== false) {
                    const existingHeader = this.config.index.headers.find(h => h.value == header.value);
                    if (existingHeader) {
                        headers.push({...header, ...existingHeader});
                    }
                }
            }

            for (let i = 0; i < this.config.index.headers.length; i++) {
                const header = this.config.index.headers[i];
                if (header.value && header.draggable === false) {
                    headers.push(header);
                }
            }

            if(headers[headers.length -1]?.width && headers[headers.length -1]?.width > 50){
                headers[headers.length -1].width -= 50;
            }

            headers.push({ value: 'column-sort', text: '', width: 50, sortable: false });

            return headers;
        },
        setHeaderHidden(header, val){
            const index = this.headers.map(item => (item.value)).indexOf(header.value);
            this.headers[index].hidden = val;
            this.visibleHeaders = this.getVisibleHeaders();
            this.saveHeaders();
        },
        clearColumnConfig(){
            this.headers = this.config.index.headers.map(header => ({ value: header.value, hidden: false }));
        },
        updatedStatus(taskId, statusCode) {
            for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                if (item.id == taskId) {
                    this.items[i].statusCode = statusCode;
                }
            }
        },
        getQueryVariables() {
            let variables = {
                isActive: false
            };
            if (this.options.sortBy && this.options.sortBy[0]) {
                variables.orderBy = {
                    column: this.options.sortBy[0],
                    type: this.options.sortDesc[0] ? 'desc' : 'asc'
                }
            } else {
                variables.orderBy = {
                    column: 'createdAt',
                    type: 'desc'
                }
            }

            let filterVariables = this.$helper.filtersToVariables(this.filters);

            variables = {
                ...variables,
                ...filterVariables
            };

            if (this.timeFilters && this.timeFilters.from && this.timeFilters.until) {
                if (!variables.where) {
                    variables.where = [];
                }

                // Het datumveld is configureerbaar via de veldkiezer (lijst-modules);
                // valt terug op createdAt voor modules zonder veldkeuze.
                const timeColumn = this.timeFilters.field || 'createdAt';

                variables.where.push({
                    column: timeColumn,
                    operator: '>=',
                    value: this.timeFilters.from.toISOString()
                });
                variables.where.push({
                    column: timeColumn,
                    operator: '<=',
                    value: this.timeFilters.until.toISOString()
                });
            }

            if (this.alterVariables) {
                variables = this.alterVariables(variables);
            }

            return variables;
        },
        getDataFromApi(options) {

            if (this.cancelRequest) {
                this.cancelRequest.cancel();
            }

            this.loading = true;

            let variables = this.getQueryVariables();

            if (options) {
                this.options = {
                    ...this.options,
                    ...options
                };
            }

            if (this.options.page) {
                variables.offset = this.options.page - 1;
            }
            if (this.options.itemsPerPage && this.options.itemsPerPage >= 0) {
                variables.limit = this.options.itemsPerPage;
            }

            if (this.alterOptions) {
                variables = this.alterOptions(variables);
            }

            if (this.treeview && this.treeview.show && this.treeview.parentIdProperty) {
                variables.whereNull = {
                    column: this.treeview.parentIdProperty,
                };
            }

            this.items = [];

            this.cancelRequest = this.$eod.getCancelRequest();

            let extra = {
                cancelToken: this.cancelRequest.token
            };

            return this.$eod.get(this.config.index.endpoint, this.config.index.fields, variables, extra).then(async (result) => {

                let items = [];
                this.totalItems = 0;

                if (result && result.data && result.data.data && result.data.data[this.config.index.endpoint]) {
                    items = result.data.data[this.config.index.endpoint].edges;
                    this.totalItems = result.data.data[this.config.index.endpoint].totalCount;

                    if (this.prepareItems) {
                        items = await this.prepareItems(items);
                    } else if (this.config.itemObject) {
                        for (let i = 0; i < items.length; i++) {
                            items[i] = new (this.config.itemObject)(items[i]);
                        }
                    }
                }

                this.items = items;

                this.$emit('loaded', this.items);

                this.$nextTick(() => {
                    this.loading = false;
                });

                return this.items;
            }).catch(e => {
                if (e.__CANCEL__) {
                    this.$log.info('Previous request aborted.', e);
                } else {
                    this.loading = false;
                    this.$log.error('Error loading items!', e);
                }
            });
        }
    }
}
</script>